module.exports = __webpack_public_path__ + "img/Weapon_276.d25225e1.png";